<template>
  <div class="ui form">
    <h4 class="ui dividing header">{{ $t("student portal") }}</h4>
    <div class="ui toggle checkbox" style="margin-bottom:15px">
      <input
        type="checkbox"
        name="create_portal_user"
        v-model="conf.create_portal_user"
      />
      <label>{{ $t("create portal user on inscription") }}</label>
    </div>
    <h4 class="ui dividing header">{{ $t("course assignation") }}</h4>
    <div class="ui grid">
      <div class="eight wide column">
        <div class="ui toggle checkbox" style="margin-bottom:15px">
          <input
            type="checkbox"
            name="send_to_assignation"
            v-model="conf.send_to_assignation"
          />
          <label>{{
            $t("on student inscription, preinscribe for section assignment")
          }}</label>
        </div>
      </div>
      <div class="eight wide column">
        <div class="field">
          <label for="">{{ $t("season selection rule") }}</label>
          <div class="ui selection dropdown" ref="season_rule_dropdown">
            <input type="hidden" name="ddwn" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field" v-show="conf && conf.season_rule == 'choose'">
          <label for="">{{ $t("select season") }}</label>
          <!-- <div class="ui fluid search" ref="season_search">
            <input class="prompt" type="text" placeholder="$t('search season')" />
            <div class="results"></div>
          </div> -->
          <div class="ui selection dropdown" ref="season_dropdown">
            <input type="hidden" name="ddwn" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui dividing header" style="margin-top:0">
      {{ $t("pensum") }}
    </h4>
    <div class="ui toggle checkbox" style="margin-bottom:15px">
      <input
        type="checkbox"
        name="show_pensum_courses"
        v-model="conf.show_pensum_courses"
      />
      <label>{{ $t("show pensum courses") }}</label>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "StudentInscriptionConfigurationModalIntegration",
  props: {
    conf: Object,
  },
  mounted() {
    let vm = this;

    vm.getSeasons()
      .then((seasons) => {
        let vls = seasons
          //   .filter((s) => {
          //     return s.is_active;
          //   })
          .map((s) => {
            return { name: s.name, value: s.season_id };
          })
          .sort((a, b) => {
            if (a.value > b.value) return -1;
            else if (a.value < b.value) return 1;
            else return 0;
          });

        window
          .jQuery(vm.$refs.season_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.conf.season = value;
            },
          });

        setTimeout(() => {
          if (vm.conf.season) {
            window
              .jQuery(vm.$refs.season_dropdown)
              .dropdown("set selected", vm.conf.season);
          }
        }, 1000);
      })
      .catch((err) => {
        error_toast(err);
      });

    let vls = [
      { name: vm.$t("last created"), value: "last" },
      { name: vm.$t("default season"), value: "default" },
      { name: vm.$t("choose one"), value: "choose" },
    ];

    window
      .jQuery(vm.$refs.season_rule_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.conf.season_rule = value;
        },
      });

    setTimeout(() => {
      if (vm.conf.season_rule) {
        window
          .jQuery(vm.$refs.season_rule_dropdown)
          .dropdown("set selected", vm.conf.season_rule);
      }
    }, 1000);
  },
  methods: {
    getSeasons() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/course/assignation/do-get-all-season-list", {})
          .then((r) => {
            resolve(r);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>
